(function () {
  const widgets = document.querySelectorAll(".async-trustpilot-widget"),
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            window.Trustpilot.loadFromElement(entry.target);
          }
        });
      },
      {
        rootMargin: "0px 0px 300px 0px",
        threshold: 0.0
      }
    );

  widgets.forEach((widget) => observer.observe(widget));
})();

var WDN = WDN || {};

if (typeof WDN.CountdownNew === "undefined") {
  WDN.CountdownNew = (function () {
    var Countdown;

    Countdown = function (config) {
      this.config = config;
      this.targetDate = new Date(config.date);
      this.outputContainer = document.querySelector("[data-countdown='" + config.id + "']");
      this.translations = WDN.CountdownTranslations;
      this.headingCampaignSettings = config.headingCampaignSettings;
      this.oldProgressPercentage = 0;
      this.fromDate = (config.fromDate && new Date(config.fromDate)) || false;
      if (!this.outputContainer) return;
      this.init();
    };

    Countdown.prototype.calculate = function () {
      this.timeDifference = this.targetDate.getTime() - new Date().getTime();
      // calculating difference based on two dates
      this.days = Math.floor(parseFloat(this.timeDifference / (1000 * 60 * 60 * 24)));
      this.hours = Math.floor((this.timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((this.timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((this.timeDifference % (1000 * 60)) / 1000);

      this.days = this.formatTime(this.days);
      this.hours = this.formatTime(this.hours);
      this.minutes = this.formatTime(this.minutes);
      this.seconds = this.formatTime(this.seconds);
    };

    Countdown.prototype.formatTime = function (time) {
      // if requested time is negative - set is as 0 instead
      time = time < 0 ? 0 : time;

      // converting time to string
      var stringTime = "" + time;

      // checking if is single digit number
      if (stringTime.length === 1 && !this.headingCampaignSettings) {
        stringTime = "0" + stringTime;
      }

      return stringTime;
    };

    Countdown.prototype.getFormattedOutput = function () {
      var tk = this.translations;
      var output = [this.days + tk.days, this.hours + tk.hours, this.minutes + tk.minutes, this.seconds + tk.seconds];

      if (this.headingCampaignSettings) {
        var output = [this.days > 0 ? this.days + tk.days : "", this.hours + tk.hours, this.minutes + tk.minutes, this.seconds + tk.seconds];
        return output.join(" ");
      }

      return output.join(tk.divider);
    };

    Countdown.prototype.percentageProgress = function () {
      var progressBar = document.querySelector('[data-countdown-progressbar="' + this.config.id + '"]');
      if (!this.fromDate || !progressBar) return false;
      var differenceBetweenTargetAndFrom = this.targetDate.getTime() - this.fromDate.getTime();
      var differenceBetweenNowAndTarget = this.targetDate.getTime() - new Date().getTime();
      var remainingProgress = (differenceBetweenNowAndTarget / differenceBetweenTargetAndFrom) * 100;
      // First run
      if (this.oldProgressPercentage === 0) {
        this.oldProgressPercentage = remainingProgress;
        progressBar.style.transform = "translateX(-" + remainingProgress + "%)";
      }
      // Only transform for each 1% decrease
      if (remainingProgress < this.oldProgressPercentage - 1) {
        this.oldProgressPercentage = remainingProgress;
        progressBar.style.transform = "translateX(-" + remainingProgress + "%)";
      }
    };

    Countdown.prototype.render = function () {
      this.outputContainer.innerHTML = this.getFormattedOutput();
      this.percentageProgress();
    };

    Countdown.prototype.handleInterval = function () {
      if (this.timeDifference < 0) {
        this.stop();
        this.handleVisibility();
        return;
      }
      this.calculate();
      this.render();
    };

    Countdown.prototype.handleVisibility = function () {
      if (!this.config.hideOnEnd) return;
      this.outputContainer.classList.add("hidden");
      if (this.config.hideParentOnEnd) {
        this.outputContainer.parentNode.classList.add("hidden");
      }
    };

    Countdown.prototype.start = function () {
      this.timer = setInterval(this.handleInterval.bind(this), 1000);
    };

    Countdown.prototype.stop = function () {
      clearInterval(this.timer);
      this.dispatchEndEvent();
    };

    Countdown.prototype.dispatchEndEvent = function () {
      this.outputContainer.dispatchEvent(
        new CustomEvent("countdown:completed", {
          detail: this
        })
      );
    };

    Countdown.prototype.init = function () {
      // calculates time difference based on config
      this.calculate();
      // outputs countdown
      this.render();

      console.warn(this.timeDifference);

      if (this.timeDifference < 0) {
        this.handleVisibility();
        return;
      }
      // countown interval starts here
      this.start();
    };

    return Countdown;
  })();
}
